import React, { useEffect } from 'react';
import Slider from "react-slick";
import './NextEvents.scss';
import arrow from 'assets/images/icons/arrow.svg';
import { Card } from 'components/Card/Card';
import useNextEventsVM from './useNextEventsVM';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import { AgendaEvent } from 'services/agenda/agenda.types';
import moment from 'moment';


export const NextEvents: React.FunctionComponent<{
    isLoading: boolean;
    data: AgendaEvent[];
}> = ({ isLoading, data }) => {
   
    const { datalists, currentEvent, setCurrentEvent } = useNextEventsVM();

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        nextArrow: <img src={arrow} alt="" className="arrow-next" />,
        prevArrow: <img src={arrow} alt="" className="arrow-prev" />,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (index: number) => {
            setCurrentEvent(data[index]);
        }
    };


    return (
        <ContentBlock isLoading={isLoading} title="Prochains événements" className="next-events">
            {data.length > 0 ? (
                <>
                    <div className="date">
                        {moment(currentEvent?.started_at).isSame(moment(), 'day') ? 'Aujourd\'hui' : moment(currentEvent?.started_at).format('dddd DD MMMM')}
                    </div>
                    <div className="events-container">
                    <Slider {...settings}>

                        {data.map((item) => (
                            <div className="event-item" key={'persons-upcoming-event-'+item.id}>
                                <div className="event">
                                    <div className="hours">
                                        <div className="start">
                                            {moment(item.started_at).format('HH:mm')}
                                        </div>
                                        <div className="end">
                                            {moment(item.ended_at).format('HH:mm')}                                                       
                                        </div>
                                    </div>
                                    <div className="separator"></div>
                                    <div className="description">
                                        <span className="nature">{item.label}</span>
                                        <span className="title">{datalists?.event_types?.[item.event_type ?? ''] ?? ''}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                        </Slider>
                    </div>
                </>
            ) : (
                <div className="no-event">Aucun événement à venir</div>
            )}
        </ContentBlock>

    );
};
